import React, { useEffect, useState } from "react";
import promo1 from '../../assets/promo-landscape/PBCASyariah.jpg';
import promo2 from '../../assets/promo-landscape/PBankBTN.jpg';
import promo3 from '../../assets/promo-landscape/PEVoucher.jpg';
import promo4 from '../../assets/promo-landscape/PKhususBaliMega.jpg';
import promo5 from '../../assets/promo-landscape/PKhususTransmartMega.jpg';
import promo6 from '../../assets/promo-landscape/PLivinPaylater.jpg';
import promo7 from '../../assets/promo-landscape/PYup.jpg';
import BgLeft from "../../assets/lobak.png";
import BgRight from "../../assets/bayam.png";
import { FiXCircle } from "react-icons/fi";


const Promotion = () => {

  const [selectedImage, setSelectedImage] = useState(null);
    useEffect(()=> {
    document.body.style.overflow = selectedImage? "hidden" : "auto";
    return () => {
        document.body.style.overflow = "auto";
    };
}, [selectedImage]);

    const promotions = [
        {
            id: 1,
            image: promo1,
            title: 'Cashback 50% BCA Syariah',
            description: "14 Februari - 31 Desember 2025 "
        },
        {
            id: 2,
            image: promo2,
            title: 'Cashback 30% Bank BTN',
            description: "01 Januari - 15 Juli 2025 "
        },
        {
            id: 3,
            image: promo3,
            title: 'Promo E-Voucher MORE',
            description: "Agustus 2025 "
        },
        {
            id: 4,
            image: promo4,
            title: 'Diskon 50% Bank Mega',
            description: "31 Juli 2025 "
        },
        {
            id: 5,
            image: promo5,
            title: 'Diskon 50% Bank Mega',
            description: "04 Agustus 2025 "
        },
        {
            id: 6,
            image: promo6,
            title: "Cashback 20% Livin' Paylater",
            description: "01 Maret - 31 Desember 2025"
        },
        {
            id: 7,
            image: promo7,
            title: 'Vourcher Diskon up to 50%',
            description: "10 Feb - 30 Juni 2025 "
        }

    ];

    return (

      <div id="ViewPromo" className="container mt-28 mx-auto px-4 py-8">
        <img
        src={BgLeft}
        alt="Background Left"
        className="absolute bottom-[-500px] left-0 md:left-[-250px] max-w-[400px] md:max-w-[600px] opacity-80 pointer-events-none hidden md:block z-[-1]"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.4, ease: "easeInOut" }}
        viewport={{ once: false }}
        />
        <img 
        src={BgRight}
        alt="Background Right"
        className="absolute bottom-[-450px] right-0 md:right-[-222px] max-w-[400] md:max-w-[600px] opacity-80 pointer-events-none hidden md:block z-[-1]"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.4, ease: "easeInOut" }}
        viewport={{ once: false }}
       />
      <div></div>
      <h1 className='mt-5 text-3xl font-bold text-pink-800 text-center italic mb-8'>"Exclusive Offers"</h1>
      {/* Responsive grid - 1 column on mobile, 2 on tablet, 3 on desktop */}
      <div className="container mx-auto px-4 bg-neutral-10 lg:bg-neutral-25 lg:py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {promotions.map((Promo) => (
          <div 
            key={Promo.image} 
            className="mt-5 relative group overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300"
            
            >
            <img 
              src={Promo.image} 
              alt=''
              className="w-full h-70 object-cover transition-transform duration-500 group-hover:scale-105 cursor-pointer"
              onClick={() => setSelectedImage(Promo.image)}
            />
            <div className="p-4 lg:flex-col gap-y-6">
              <div className="flex-1">
                <h3 className=" text-xl text-pink-800 font-bold font-national2condensed text-neutral-900 uppercase mb-2 h-14 line-clamp-2 text-black">
                  {Promo.title}
                </h3>
            <p className="text-xs text-neutral-500">
              <span>Valid Until</span>
              <span className="mr-1">:</span>
              <span>{Promo.description}</span></p>
            {/* <div className="absolute inset-0  flex items-end p-4"> */}
            {/* bg-gradient-to-t from-black/70 to-transparent */}
              {/* <h2 className="text-white text-xl font-bold">{title}</h2> */}
              {/* <h3 className="text-white text-sm font-normal">{promo.description}</h3> */}
              </div>
               </div>
               </div>
               
        ))}
        {/* Empty div to maintain grid balance when there are 7 items */}
        {/* <div className="sm:hidden lg:block"></div> */}
        {selectedImage && (
          <div 
              className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
              initial={{opacity:0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              transition={{duration: 0.4}}                
          >
            <div className="relative max-w-4xl w-full p6">
              <button
              onClick={()=> setSelectedImage(null)}
              className="absolute top-4 right-4 text-white text-3xl hover:text-pink-700 transition">
                <FiXCircle/>
              </button>
              <img
              src={selectedImage}
              alt=""
              className="w-full h-auto rounded-lg pointer-event-none"/>
        </div>
        </div>
    )
  }
  </div>
  </div>
</div>
);
};
export default Promotion;
    